<script lang="ts">
    import {
        Listbox,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
    } from '@rgossiaux/svelte-headlessui';
    import type {ComponentSize} from '../types';

    export let id: string = null;
    export let options: (string | number)[] = [];
    export let value: string | number;
    export let disabled = false;
    export let use = [];
    export let size: ComponentSize = 'md';
    export let additionalButtonClass = '';
    export let additionalContainerClass = '';
    export let isOptionDisabled: (option: string | number) => boolean = () => false;

</script>

<template>
    <Listbox {id} class="dropdown dropdown-listbox {additionalContainerClass}" {value} {disabled} {...$$restProps} on:change let:open>
        <slot name="label"/>
        <ListboxButton type="button"
                       role="combobox"
                       {value}
                       class="input-{size} btn dropdown-toggle {open ?' active': ''} {additionalButtonClass}"
                       {use}>
            <slot name="button"/>
        </ListboxButton>
        <ListboxOptions unmount={false} class="dropdown-menu size-{size} {open ? 'opened' : ''}">
            {#each options as option}
                <ListboxOption value={option} disabled={isOptionDisabled(option)} let:active let:selected let:disabled>
                    <div class="dropdown-menu-option" class:active class:selected class:disabled>
                        <slot name="option" {option}/>
                    </div>
                </ListboxOption>
            {/each}
        </ListboxOptions>
    </Listbox>
</template>

<style lang="less">
    :global(.dropdown-listbox .dropdown-menu) {
        width: 100%;
        height: auto;
        max-height: 200px;
        overflow-x: hidden;
    }
</style>